export default __webpack_public_path__ + "static/media/cover-image.554083a0.png";